<template>
    <div class="at-replay_msg">
        <textarea 
          :id="`input-text-message-${chatInfo.chatId}`" 
          ref="messageInputRef" 
          type="text" 
          v-model="messageInput" 
          name="replay" 
          :placeholder="TRANS.type_message"
          autocomplete="off"
          class="at-form-control at-form-replay"
          ></textarea>
        <div v-if="shareEmoji" class="at-emojibar" :style="styles.stickyButton" ref="emojiPickerWrapperRef">
            <picker
                set="twitter"
                emoji="point_up"
                :data="emojiIndex"
                v-if="showEmojiPicker"
                :style="styles.emojiPicker"
                :title="STRINGS.PICK_YOUR_EMOJI"
                @select="emojiClicked"
            />
            <div :title="STRINGS.EMOJI" :style="styles.composerIcon" @click="toggleEmojiPicker" >
                <img :alt="STRINGS.INSERT_EMOTICON" :style="styles.composerIcon.img" :src="icons[showEmojiPicker ? 'close' : 'emoji']" />
            </div>
        </div>
        <a v-if="isMessangerChat" @click.prevent="sendTextMessage()" href="javascript:void(0)" class="at-sendmsg" ><i class="guppy-send"></i></a>
      </div>
</template>

<script>
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast";
import { mapState } from "vuex";
import { GUPPYCHAT_SETTINGS, GUPPYCHAT_CONSTANTS } from "../../../resources/constants";
import GuppyChatManager from "../../../resources/controller";
import RestApiManager   from "../../../resources/RestApiController";
import closeIcon        from "./resources/close.png";
import emojiIcon        from "./resources/emoji.png";
import * as style       from "./style";
import jQuery from "jquery";
let emojiIndex = new EmojiIndex(data);
export default {
    name:'GuppyChatSendTextMessage',
    components :{ Picker },
    props : {
      'chatId':{
        type: String,
        required : false,
        default : ()=>{
          return null
        }
      },
    },
    data(){
        return {
            shareEmoji          : GUPPYCHAT_SETTINGS.shareEmoji,
            emojiIndex          : emojiIndex,
            showEmojiPicker     : false,
        }
    },
    computed:{
        STRINGS() {
            return GUPPYCHAT_CONSTANTS;
        },
        messageInput : {
            get () {
                return this.$store.getters.getMessageInput(this.chatId)
            },
            set (value) {
                this.$store.commit('updateMessageInput', { 'text' : value, 'chatId' : this.chatId })
            }
        },
        quoteMessage(){
            return this.$store.getters.getQuoteMessage(this.chatId)
        },
        quoteMessageId(){
            return this.$store.getters.getQuoteMessageId(this.chatId)
        },
        CurrentDate: function(){
            var myDate = new Date();
            let monthsList = ['January ', 'February ', 'March ', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
            let date = myDate.getDate();
            let month = monthsList[myDate.getMonth()];
            let year = myDate.getFullYear();
            return `${month} ${date}, ${year}`;
        },
        icons() {
            return {
                close: closeIcon,
                emoji: emojiIcon,
            }
        },
        styles(){
            return {
                stickyButton: style.stickyButtonStyle(),
                emojiPicker: style.emojiPickerStyle(),
                composerIcon: style.composerIconStyle(this.isBlockedByMe),
            }
        },
        chatInfo(){
            return this.$store.getters.getChatInfo(this.chatId)
        },
        ...mapState({
            userProfile     : state => state.userProfile,
            isMessangerChat : state => state.isMessangerChat,
            isBlockedByMe   : state => {
                return state.chatInfo.isBlocked
            }
        })
    },
    watch:{
        isBlockedByMe(newValue) {
            if (newValue) {
            this.showEmojiPicker = false;
            this.showStickerPicker = false;
            }
        },
        messageInput(value) {
        let groupMembers = [];
        if(this.chatInfo.chatType== 2 && this.chatInfo.groupDetail){
          for (let [id] of Object.entries(this.chatInfo.groupDetail.memberAvatars)) {
            if(this.userId != id){
              groupMembers.push(id);
            }
          }
        }
        let payload = {
          userName   : this.userProfile.userName,
          chatType   : this.chatInfo.chatType,
          chatId     : this.chatInfo.chatId,
          senderId   : this.userId,
          text       : value,
          groupMembers,
        }
        this.isTyping(payload);
      }
    },
    updated() {
        this.autoHeightInput();
    },
    methods:{
        autoHeightInput(){
            let inputtextId = `#input-text-message-${this.chatInfo.chatId}`;
            var elmnt = document.getElementById(`input-text-message-${this.chatInfo.chatId}`);
            if(elmnt){
                let paddingTop = jQuery(inputtextId).css('padding-top').split('px')[0];
                let paddingBottom = jQuery(inputtextId).css('padding-bottom').split('px')[0];
                let padding = Number(paddingTop) + Number(paddingBottom);
                jQuery(inputtextId).height(0).height( elmnt.scrollHeight - padding);
                if (jQuery(inputtextId).height() >= 60) {
                    jQuery('textarea.at-form-replay').css("overflow", "auto");
                }else {
                    jQuery('textarea.at-form-replay').css("overflow", "hidden");
                }
            }
        },
        isTyping(payload){
            this.$store.dispatch('triggerclientEvents', {'event':'isTyping', payload});
        },
        toggleEmojiPicker() {
            if(this.isBlockedByMe) return;
            this.showEmojiPicker = !this.showEmojiPicker;
        },
        emojiClicked(emoji) {
            this.$nextTick(() => {
            try {
                if (this.$refs && this.$refs.messageInputRef) {
                const element = this.$refs.messageInputRef;
                var val       = element.value;
                var start     = element.selectionStart, end = element.selectionEnd;
                element.value = val.slice(0, start) + emoji.native + val.slice(end);
                element.focus();
                var caretPos  = start + emoji.native.length;
                element.setSelectionRange(caretPos, caretPos);
                this.setMessageInput(element);
                }
            } catch (error) {
                this.logError("Error in emoji click", error);
            }
            });
        },
        setMessageInput(element) {
            this.messageInput = element.value;
        },
        async sendTextMessage(){
            let data = {
                receiverId    : Number(this.chatInfo.chatType) == 1 ? this.chatInfo.chatId.split('_')[0] :  Number(this.chatInfo.chatType) == 0 ? this.chatInfo.postReceiverId : '',
                userId        : this.userId,
                chatId        : this.chatInfo.chatId,
                groupId       : Number(this.chatInfo.chatType) == 2 ? this.chatInfo.chatId : '',
                postId        : Number(this.chatInfo.chatType) == 0 ? this.chatInfo.postId : '',
                chatType      : Number(this.chatInfo.chatType),
                message       : this.messageInput,
                isSender      : true,
                replyTo       : '',
                latitude      : '',
                longitude     : '',
                messageType   : 0,
                messageStatus : 0,
                replyId       : this.quoteMessageId,
                timeStamp     : Math.floor(new Date().getTime()/1000),
                messageSentTime : this.CurrentDate,
                metaData        : { randNum       : Math.floor(Math.random() * 999999999) },
            }

            if( this.messageInput ) {
                if( this.showEmojiPicker ) {
                    this.showEmojiPicker = false;
                }

                if( this.quoteMessage ) {
                    data["replyMessage"] = this.quoteMessage;
                }

                this.$store.commit("appendMessage", data);
                this.$store.commit('removeQuote', {chatId : this.chatInfo.chatId});
                this.scrollListToBottom();

                this.$store.commit('updateMessageInput', { 'text' : '', 'chatId' : this.chatInfo.chatId });
                let response = await RestApiManager.sendMessage(data, this.chatInfo.chatId);
                if(response.type == 'error'){
                    this.alertBox('error', this.TRANS.error_title, response.message_desc)
                }
            }
        },
        scrollListToBottom(scrollHeight = 0) {
            GuppyChatManager.messagesScrollList(scrollHeight, this.chatInfo.chatId);
        },
    },
    mounted(){
        const ele = document.getElementById(`input-text-message-${this.chatInfo.chatId}`);
        let _this = this;
        ele.addEventListener('keydown', function (e) {
        let keyCode = e.which || e.keyCode;
            if (keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                _this.sendTextMessage();
            }
        });
    }
}
</script>

<style>

</style>